import React, { Dispatch, SetStateAction } from "react";
import "./DNA.scss";
import { DNAElement } from "./DNAElement/DNAElement";
import { DNAElementBox } from "../../DNAElementBox/DNAElementBox";

export type DNAFragmentValue = -2 | -1 | 0 | 1 | 2;
export type DNAElementValue = [DNAFragmentValue, DNAFragmentValue, DNAFragmentValue, DNAFragmentValue];
export type DNAValue = [DNAElementValue, DNAElementValue, DNAElementValue];
export type DNAAnswers = [DNAElementValue[], DNAElementValue[], DNAElementValue[]];

interface IProps {
    value: DNAValue
    setValue?: Dispatch<SetStateAction<DNAValue>>
}

export function DNA({ value, setValue }: IProps) {
    const setElementValue = (index: number) => {
        return setValue ? ((elementValue: DNAElementValue) => {
            setValue((prevState) => {
                prevState[index] = elementValue;
                return [...prevState];
            });
        }) : undefined;
    };
    return (
        <div className="dna">
            { value.map((dnaElementValue, index) => {
                return <DNAElementBox key={index}><DNAElement value={dnaElementValue} onChange={setElementValue(index)} /></DNAElementBox>
            }) }
        </div>
    )
}
